module.exports = __webpack_public_path__ + "img/pay.eff92b80.svg";